// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"10215787","166":"c0e4509c","230":"274f97d6"}[chunkId] + ".chunk.js";
};